import API from './api';
import { SET_INFO, SET_EST_PRICE, SET_DIFF_PRICE } from './_store/types';

//  Get property information
const getListingInfo = function(store) {
    let module = this.$root.moduleData.find(m => m.name === 'md-sold-detail');
    if (module && module.data) {
        let { info = {} } = module.data.listingDetail;
        store[SET_INFO](info);
    }
};
const getEstPrice = async function(store) {
    let { streetAddress, cityAddress, soldPrice } = store.info;
    //  get a valuation
    if (streetAddress && cityAddress) {
        let address = `${streetAddress}, ${cityAddress}`;
        let { data = {} } = await API.getEstPrice.call(this, { address });
        if (data.zestimate) {
            let estPrice = Number(data.zestimate.amount) || 0;
            store[SET_EST_PRICE](estPrice);
            store[SET_DIFF_PRICE](estPrice ? estPrice - soldPrice : 0);
        }
    }
};

export function asyncData(store) {
    let ps = [];
    ps.push(getListingInfo.call(this, store));
    ps.push(getEstPrice.call(this, store));
    return Promise.all(ps);
}
